import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from '../../reducers/auth/auth.reducer';

export const selectAuthState = createFeatureSelector<fromAuth.State>(
  fromAuth.authFeatureKey
);


export const selectAuthToken = createSelector(
  selectAuthState,
  (state: fromAuth.State) => state.authToken
);
